/* eslint-disable */
import axios from 'axios'
import store from '../store'
import { MessageBox, Message} from 'element-ui'

export function fetch(options){
  return new Promise((resolve, reject) => {
    // 设置请求头
    var header = {'Content-Type': 'application/json'}

    if (store.state.login.isLogin)
    header = combineObj(store.state.login.adminer, header)
    
    if (options.headers) header = combineObj(options.headers, header)

    // 初始化axios
    const instance = axios.create({
      headers: header,
      transformRequest: [function(data) {
        data = JSON.stringify(data)
        return data
      }],
      // paramsSerializer: function(params) {
      //   return JSON.stringify(params)
      // },
      timeout: 300 * 1000
    });

    // then 请求成功之后进行什么操作
    instance(options).then(response => {
        if (response.data.code === 1040) {
            Message('暂无' + response.data.data + '权限')
        } else if (response.data.code === 1001) {
            MessageBox('您的账号已过期，请重新登录。', '提示', {
              confirmButtonText: '确定',
              type: 'warning'
            }).then(() => {
                localStorage.setItem("isLogin", false)
                location.reload()
            }).catch(() => {});
        } else if (response.data.code === 1011) {
            MessageBox('您的账号在异地登录，如果不是本人操作，请重新登录后修改登录密码。', '提示', {
              confirmButtonText: '确定',
              type: 'warning'
            }).then(() => {
                localStorage.setItem("isLogin", false)
                location.reload()
            }).catch(() => {});
        } else {
            // 把请求到的数据发到引用请求的地方
            resolve(response);
        }
    }).catch(error => {
        Message('服务器请求错误')
        console.log('请求异常信息：' + error)
        reject(error)
    });
  });
}

function combineObj(o,n) {
    for (var p in n) {
        if(n.hasOwnProperty(p) && (!o.hasOwnProperty(p)))
            o[p]=n[p]
    }

    return o
}


// WEBPACK FOOTER //
// ./src/axios/fetch.js